import * as React from 'react';
import { GameTag } from '../../../http/protocol';
import { 
  getSelectedGameTagNameIds,
  findGameTagsByNameIds
} from '../utils/GameTagUtils';
import '../styles/CashbackConfig.scss';

interface Props {
  gameTags: GameTag[];
  selectedGameTags: GameTag[];
  onSelectionChange: (selectedTags: GameTag[]) => void;
  disabled?: boolean;
}

export const GameTagSelector: React.FC<Props> = ({
  gameTags,
  selectedGameTags,
  onSelectionChange,
  disabled = false
}) => {
  const selectedNameIds = getSelectedGameTagNameIds(selectedGameTags);
  const selectSize = Math.min(Math.max(gameTags.length, 1), 6);

  const handleSelectionChange = React.useCallback((event: React.ChangeEvent<HTMLSelectElement>) => {
    const target = event.target;
    const selectedValues: string[] = [];
    
    for (let i = 0; i < target.options.length; i++) {
      if (target.options[i].selected) {
        selectedValues.push(target.options[i].value);
      }
    }
    
    const selectedTags = findGameTagsByNameIds(selectedValues, gameTags);
    onSelectionChange(selectedTags);
  }, [gameTags, onSelectionChange]);

  return (
    <div className="form-group">
      <label className="col-sm-2 control-label" htmlFor="game-tags-select">
        Items List
      </label>
      <div className="col-sm-10">
        <select 
          id="game-tags-select"
          multiple={true}
          size={selectSize}
          className="form-control game-tags-select"
          value={selectedNameIds}
          onChange={handleSelectionChange}
          disabled={disabled}
          aria-label="Select game tags for cashback configuration"
          aria-describedby="game-tags-help"
        >
          {gameTags.map(tag => (
            <option 
              key={tag.id} 
              value={tag.nameId || ''}
              disabled={!tag.nameId}
            >
              {tag.name || 'Unnamed Tag'}
            </option>
          ))}
        </select>
        <span 
          id="game-tags-help"
          className="help"
        >
          Select one or more game tags to include/exclude from the cashback/rakeback calculations
        </span>
      </div>
    </div>
  );
};
